import * as Yup from 'yup';

export const validationSchema = Yup.object({
    customerId: Yup.string().required('Customer is required.').nullable(),
    jobReferenceId: Yup.string().required('Job reference id is required.').nullable(),
    incotermCode: Yup.string().required('Delivery term is required.').nullable(),
});
